import { createSelector } from 'reselect'
import featureStateSelector from './featureStateSelector'

export const totalSelector = createSelector(featureStateSelector, (state) => state.pagination.total)
